require.register("app/product/price/LogsView", function(exports, require, module){
  $0
  
});

